import { Card, Group, Popover, Stack, Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import { Missing } from "@tfg/ui"
import _ from "lodash"
import { useTranslation } from "react-i18next"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { Property } from "~/components/Property"
import { CountryCell } from "~/components/cells/CountryCell"
import { useGetOperations } from "~/utils/operations"

type Props = {
  operationNodes: LibraryResponses.OperationNode[]
  showOnlyMainFabric: boolean
}
export const OperationCountriesCell = ({
  operationNodes,
  showOnlyMainFabric,
}: Props) => {
  const byActivity = _.groupBy(operationNodes, (x) => x.activityName)

  const sections = Object.entries(byActivity).map(
    ([activity, operationNodes]) => (
      <OperationCountriesByActivityCell
        key={activity}
        activity={activity}
        operationNodes={operationNodes}
        showOnlyMainFabric={showOnlyMainFabric}
      />
    )
  )

  return <>{sections}</>
}

type PropsByActivity = {
  activity: LibraryResponses.OperationNode["activityName"]
  operationNodes: LibraryResponses.OperationNode[]
  showOnlyMainFabric: boolean
}
const OperationCountriesByActivityCell = ({
  activity,
  operationNodes,
  showOnlyMainFabric,
}: PropsByActivity) => {
  const { t } = useTranslation("products")
  const [opened, { close, open }] = useDisclosure(false)

  operationNodes = operationNodes.filter((x) => !showOnlyMainFabric || x.isMain)

  const activityInfo = useGetOperations()[activity]

  return (
    <Popover
      width={300}
      shadow="md"
      opened={opened}
      withArrow
      withinPortal
      position="right"
    >
      <Popover.Target>
        <Card
          p="xs"
          radius="md"
          withBorder
          onMouseEnter={() => operationNodes.length && open()}
          onMouseLeave={() => operationNodes.length && close()}
        >
          <Group align="flex-start" wrap="nowrap">
            {activityInfo.icon && <activityInfo.icon size={20} />}
            {operationNodes.length ? (
              <Stack gap={4} align="flex-start" justify="flex-start">
                {operationNodes.map((node) => (
                  <CountryCell
                    dimmed={
                      false /*TODO node.operation !== "not-entered-yet" &&
                      !node.operation.isIrClosed*/
                    }
                    key={node.id}
                    countryIso3166={
                      node.operation !== "not-entered-yet"
                        ? node.operation.country.value
                        : null
                    }
                  />
                ))}
              </Stack>
            ) : (
              <Missing />
            )}
          </Group>
        </Card>
      </Popover.Target>
      <Popover.Dropdown style={{ pointerEvents: "none" }}>
        <Group mb="md" gap="xs">
          {activityInfo.icon && <activityInfo.icon size={20} />}
          <Text style={{ fontWeight: "bold" }}>{activityInfo.name}</Text>
        </Group>
        <Stack gap="xl">
          {operationNodes.map((node) => {
            const operation =
              node.operation === "not-entered-yet" ? null : node.operation

            return (
              <Stack key={node.id} gap={4}>
                <Property
                  label={t("details.properties.country")}
                  value={
                    <CountryCell
                      style={{ fontWeight: "bold" }}
                      countryIso3166={operation?.country.value}
                    />
                  }
                />
                <Property
                  label={t("details.properties.item")}
                  value={node.reference}
                />
                <Property
                  label={t("details.properties.supplier")}
                  value={operation?.productionSite.value?.companyName}
                />
                <Property
                  label={t("details.properties.address")}
                  value={operation?.productionSite.value?.address}
                />
              </Stack>
            )
          })}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  )
}
